import React from 'react'
import Breadcrumb from '../../breadcrumbMeta/Breadcrumb';
import Meta from '../../breadcrumbMeta/Meta';

import "./policy.css"


const Temscondtion = () => {
  return (
    <>
      <Meta title={"Terms condtion"}/>
      <Breadcrumb title="Terms condtion"/>
      <div className="termscondition">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="policy">
                    <h3  className='fw-bold'>The Standared Lorem ipsum dolor</h3>
                        <p className='fs-6' >Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse error in modi optio magnam sit laboriosam, earum architecto rerum tempora cum at dignissimos ipsum fugit officia beatae accusamus deleniti! Quibusdam?</p>
                        <h3  className='fw-bold'>The Standared Lorem ipsum dolor</h3>
                        <p className='fs-6' >Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse error in modi optio magnam sit laboriosam, earum architecto rerum tempora cum at dignissimos ipsum fugit officia beatae accusamus deleniti! Quibusdam?</p>
                        <h3  className='fw-bold'>The Standared Lorem ipsum dolor</h3>
                        <p className='fs-6' >Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse error in modi optio magnam sit laboriosam, earum architecto rerum tempora cum at dignissimos ipsum fugit officia beatae accusamus deleniti! Quibusdam?</p>
                        <h3  className='fw-bold'>The Standared Lorem ipsum dolor</h3>
                        <p className='fs-6' >Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse error in modi optio magnam sit laboriosam, earum architecto rerum tempora cum at dignissimos ipsum fugit officia beatae accusamus deleniti! Quibusdam?</p>
                        <h3  className='fw-bold'>The Standared Lorem ipsum dolor</h3>
                        <p className='fs-6' >Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse error in modi optio magnam sit laboriosam, earum architecto rerum tempora cum at dignissimos ipsum fugit officia beatae accusamus deleniti! Quibusdam?</p>

                    </div>
                </div>
            </div>
        </div>
      </div>
      
    </>
  )
}

export default Temscondtion
